import { Subject, takeUntil } from 'rxjs';

import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { UserService } from 'app/core/user/user.service';
import { AuthService } from '@admin/auth/services/auth.service';

import { ClientInfoDto, UserInfoDto } from '@sociuu/interfaces';

import { User } from 'app/core/user/user.types';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() public showAvatar: boolean = false;
  public user: User;
  public userInfo: UserInfoDto;
  public clientInfo: ClientInfoDto;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private _userService: UserService,
    private _authService: AuthService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  public ngOnInit(): void {
    // Subscribe to user changes
    this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
      this.user = user;

      // Mark for check
      this._changeDetectorRef.markForCheck();
    });

    this.getClientInfo();
  }

  /**
   * On destroy
   */
  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  public updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.user) {
      return;
    }

    // Update the user
    this._userService
      .update({
        ...this.user,
        status,
      })
      .subscribe();
  }

  /**
   * Sign out
   */
  public signOut(): void {
    this._authService.logout();
  }

  public settings(): void {
    this._router.navigate(['/account/settings']);
  }

  public getClientInfo(): void {
    if (this._authService.clientInfo.value) this.clientInfo = this._authService.clientInfo.value;
    if (this._authService.currentUser.value) this.userInfo = this._authService.currentUser.value;
  }
}
